

import axios from 'axios'


export const GetSubscriber = async ({ idList, listGuid, idUser, userHash }) => {


  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    url: '/frontend/webMethods/Subscriber.asmx/GetSubscriber',
    data: JSON.stringify({
      idList,
      listGuid,
      idUser,
      userHash
    })
  }).then(response => {
    const payload = JSON.parse(response.data.d)

    if ('type' in payload && payload['type'] === 'FrontendException') {
      throw new Error(payload.message)
    }

    return payload
  })
}

